import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../context/AlertContext';
import { Mic, Notes } from '@mui/icons-material';
import documentServices from '../services/documentServices';


function DocumentTextNote({documentId,callBack}) {
    const {AppAlert } = useAlert()
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    const [note,setNote] = useState("");
    const [listining,setListningStatus] = useState(false)

    const listen = () =>{
        let SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        let r = new SR();
        r.start();
        r.onstart = (e) =>{
            setListningStatus(true);
        }
        r.onend = (e) =>{
            //console.log("ended")
            setListningStatus(false);
        }
        r.onresult = (e) =>{
            //console.log(e);
            let transcript = e.results[0][0].transcript
            console.log(transcript);
            let _note = note == "" ? transcript : note+" "+transcript;
            setNote(_note);
        }
    }


    const onSubmit = () =>{
        setSavingStatus(true);
        let payload = {
            documentId:documentId,
            note:note,
        }
        documentServices.addTextNote(payload).then( (res)=>{
            AppAlert(res.msg)
            callBack();
        }).catch( (error) => {
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setDialogStatus(false);
            setSavingStatus(false);
        })
        
    }

    return (
        <>
            <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><Notes /></div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12'>
                             <span className='float-end'>
                                {listining ? "Listening..." :<button type="button" className="btn btn-outline-default" onClick={listen} > <Mic /> </button> }
                            </span>
                        </div>
                    
                        <div className='col-md-12'>
                            <div className="form-floating mb-3 ">
                                <textarea  className="form-control"  placeholder=""  value={note} onChange={(e)=>setNote(e.target.value)} style={{height:100}} />
                                <label >Type your note here ... </label>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className='row'>
                        <div className='col-md-12'>
                            {savingInProgress && <LinearProgress />}
                            {!savingInProgress &&
                                <>
                                    <button className='btn btn-outline-primary me-2' onClick={()=>setDialogStatus(false)} >Cancel</button>
                                    <button className='btn btn-primary' disabled={note===""} onClick={onSubmit}>Save</button>
                                </>
                            }
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DocumentTextNote